// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._v5641xzp{transition:max-height .3s}._1bsb1osq{width:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/flag/dist/esm/internal/expander.compiled.css"],"names":[],"mappings":";AACA,WAAW,yBAAyB,CAAC,WAAW,UAAU","sourcesContent":["\n._v5641xzp{transition:max-height .3s}._1bsb1osq{width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
